import { render, staticRenderFns } from "./EduSideBar.vue?vue&type=template&id=4f4a9cd7&scoped=true"
import script from "./EduSideBar.vue?vue&type=script&lang=js"
export * from "./EduSideBar.vue?vue&type=script&lang=js"
import style0 from "./EduSideBar.vue?vue&type=style&index=0&id=4f4a9cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a9cd7",
  null
  
)

export default component.exports